import { useEffect, useState } from 'react'
import './Portal.css'
import { IntranetHome } from './IntranetHome'
import { authedGet } from '../lib/intranet_tools_service'
import { MagnoUser } from '../lib/types'

export function Portal() {
  const [scientaOpen, setScientaOpen] = useState(false)
  const [copraOpen, setCopraOpen] = useState(false)
  const [page, setPage] = useState('intranet')
  const [user, setUser] = useState<MagnoUser | undefined>()

  useEffect(() => {
    const loadUser = async () => {
      const result = await authedGet('user/current')
      const json = await result.json()
      setUser(json)
    }
    loadUser()
  }, [])

  const onLogout = (e: any) => {
    e.preventDefault()
    localStorage.removeItem('MagnoToken')
    window.location.href = '/login'
    return null
  }

  const onSetPage = (e: React.MouseEvent, page: string) => {
    e.stopPropagation()
    onClickAway()
    setPage(page)
  }

  if (!localStorage.getItem('MagnoToken')) {
    window.location.href = '/login'
    return null
  }
  const token = localStorage.getItem('MagnoToken')

  const formatter = new Intl.DateTimeFormat('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

  const formattedDate = formatter.format(new Date())

  const onClickAway = () => {
    setCopraOpen(false)
    setScientaOpen(false)
  }

  const onOpenSubmenu = (e: React.MouseEvent, menu: string) => {
    e.stopPropagation()
    onClickAway()
    if (menu === 'copra') setCopraOpen(!copraOpen)
    else if (menu === 'scienta') setScientaOpen(!scientaOpen)
  }

  return (
    <div className="intranet-portal" onClick={onClickAway}>
      <div className="buttonbar">
        <div className="btnbar_button">
          <a onClick={(e) => onSetPage(e, 'intranet')} href="#">
            <div className="btnbar_image">
              <svg
                className="btnbar_icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                ></path>
              </svg>
            </div>
            <div style={{ fontSize: 11 }}>Dashboard</div>
          </a>
        </div>

        <div className="btnbar_button">
          <a onClick={(e) => onSetPage(e, 'proformas')} href="#">
            <div className="btnbar_image">
              <svg
                className="btnbar_icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
                ></path>
              </svg>
            </div>
            <div style={{ fontSize: 11 }}>Proformas</div>
          </a>
        </div>

        <div
          className="btnbar_button"
          id="btnbar_scienta"
          onClick={(e) => onOpenSubmenu(e, 'scienta')}
        >
          <div className="btnbar_image">
            <div className="btnbar_scienta"></div>
          </div>
          <div className="btnbar_subtitle">
            Scienta
            <div className="btnbar_caret">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </div>
          </div>
          <div
            className="btnbar_dropdown"
            id="dropdown_scienta"
            style={{ display: scientaOpen ? 'block' : 'none' }}
          >
            <div className="btnbar-flex">
              <a
                target="_blank"
                className="btnbar-option"
                href="https://magnoitrecruitment.mijnscienta.nl/"
              >
                Quality Management
              </a>
              <svg
                className="btnbar-option btnbar-nav"
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                aria-hidden="true"
                height="13px"
                width="13px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                ></path>
              </svg>
            </div>
            <div className="btnbar-flex">
              <a target="_blank" href="https://helpdesk.scienta.nl/Tickets">
                Helpdesk
              </a>
              <svg
                className="btnbar-option btnbar-nav"
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                aria-hidden="true"
                height="13px"
                width="13px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                ></path>
              </svg>
            </div>
          </div>
        </div>

        <div
          className="btnbar_button"
          id="btnbar_copra"
          onClick={(e) => onOpenSubmenu(e, 'copra')}
        >
          <div className="btnbar_image">
            <svg
              className="btnbar_icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              ></path>
            </svg>
          </div>
          <div className="btnbar_subtitle">
            COPRA
            <div className="btnbar_caret">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </div>
          </div>
          <div
            className="btnbar_dropdown"
            id="dropdown_copra"
            style={{ display: copraOpen ? 'block' : 'none' }}
          >
            <a target="_blank" href="https://copra.magno-it.nl">
              COPRA
            </a>
            <a onClick={(e) => onSetPage(e, 'copra-management-tool')} href="#">
              Management tool
            </a>
            <a onClick={(e) => onSetPage(e, 'phase-management')} href="#">
              Phase management
            </a>
          </div>
        </div>

        <div className="btnbar_button" id="btnbar_christmas">
          <a onClick={(e) => onSetPage(e, 'christmas-gifts')} href="#">
            <div className="btnbar_image">
              <svg
                className="btnbar_icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                ></path>
              </svg>
            </div>
            <div style={{ fontSize: 11 }}>Gifts</div>
          </a>
        </div>
      </div>
      <div className="top">
        <table width="100%">
          <tbody>
            <tr>
              <td width="33%" align="right"></td>
              <td width="33%" align="right"></td>
              <td></td>
            </tr>
            <tr>
              <td width="33%" align="left">
                Dashboard - {user?.name}
              </td>
              <td width="33%" align="center">
                <div id="Div1">&nbsp;&nbsp;&nbsp;</div>
              </td>
              <td width="33%" align="right">
                {formattedDate}
              </td>
            </tr>
            <tr>
              <td width="33%" align="right"></td>
              <td width="33%" align="right"></td>
              <td width="33%" style={{ fontSize: 8 }} align="right">
                <a className="logout" onClick={onLogout}>
                  Log out
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="portal">
        {page === 'intranet' && <IntranetHome />}
        {page === 'testimonials' && (
          <iframe
            className="portal-iframe"
            src={`https://intranet.magno-it.nl/testimonials?token=${token}`}
          />
        )}
        {page === 'proformas' && (
          <iframe
            className="portal-iframe"
            src={`https://proformas.magno-it.nl/?token=${token}`}
          />
        )}
        {page === 'phase-management' && (
          <iframe className="portal-iframe" src={`/phase-management`} />
        )}
        {page === 'christmas-gifts' && (
          <iframe className="portal-iframe" src={`/christmas-gifts`} />
        )}
        {page === 'copra-management-tool' && (
          <iframe className="portal-iframe" src={`/copra-management-tool`} />
        )}
      </div>
    </div>
  )
}
